import * as yup from 'yup';

export const uploadDocumentSchema = yup.object().shape({
  name: yup.string()
    .required('Document Name is required')
})
